import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Guidances from "./pages/Guidances";
import Energetique from "./pages/Energetique";
import ServiceDetail from "./pages/ServiceDetail";
import About from "./pages/About";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import Checkout from "./pages/Checkout";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Intake from "./pages/Intake";
import Booking from "./pages/Booking";
import Confirmation from "./pages/Confirmation";
import Account from "./pages/Account";
import Verify from "./pages/Verify";
import Admin from "./pages/Admin";
import Legal from "./pages/Legal";
import Retractation from "./pages/Retractation";
import Reclamations from "./pages/Reclamations";
import Rgpd from "./pages/Rgpd";
import NewsletterUnsubscribe from "./pages/NewsletterUnsubscribe";
import EntreLuiEtMoi from "./pages/EntreLuiEtMoi";
import GuideTarot from "./pages/GuideTarot";
import TirageADistance from "./pages/TirageADistance";
import Cartomancie from "./pages/Cartomancie";
import Tarifs from "./pages/Tarifs";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        {/* Admin is full-screen (no public layout) */}
        <Route path="/admin" element={<Admin />} />
        <Route
          path="*"
          element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/guidances" element={<Guidances />} />
                <Route path="/guidances/:slug" element={<ServiceDetail />} />
                <Route path="/energetique" element={<Energetique />} />
                <Route path="/energetique/:slug" element={<ServiceDetail />} />
                <Route path="/a-propos" element={<About />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/commander/:slug" element={<Checkout />} />
                <Route path="/paiement/succes" element={<PaymentSuccess />} />
                <Route path="/paiement/annule" element={<PaymentCancel />} />
                <Route path="/informations" element={<Intake />} />
                <Route path="/reservation" element={<Booking />} />
                <Route path="/confirmation" element={<Confirmation />} />
                <Route path="/espace" element={<Account />} />
                <Route path="/espace/verifier" element={<Verify />} />
                <Route path="/mentions-legales" element={<Legal page="mentions" />} />
                <Route path="/cgv" element={<Legal page="cgv" />} />
                <Route path="/confidentialite" element={<Legal page="confidentialite" />} />
                <Route path="/cookies" element={<Legal page="cookies" />} />
                <Route path="/avertissement" element={<Legal page="avertissement" />} />
                <Route path="/mediation" element={<Legal page="mediation" />} />
                <Route path="/retractation" element={<Retractation />} />
                <Route path="/reclamations" element={<Reclamations />} />
                <Route path="/mes-donnees" element={<Rgpd />} />
                <Route path="/newsletter/desinscription" element={<NewsletterUnsubscribe />} />
                <Route path="/entre-lui-et-moi" element={<EntreLuiEtMoi />} />
                <Route path="/guide-du-tarot" element={<GuideTarot />} />
                <Route path="/tirage-de-cartes-a-distance" element={<TirageADistance />} />
                <Route path="/cartomancie" element={<Cartomancie />} />
                <Route path="/tarifs" element={<Tarifs />} />
              </Routes>
            </Layout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
